import { render, staticRenderFns } from "./Col.vue?vue&type=template&id=400d77ea&scoped=true&"
import script from "./Col.vue?vue&type=script&lang=js&"
export * from "./Col.vue?vue&type=script&lang=js&"
import style0 from "./Col.vue?vue&type=style&index=0&id=400d77ea&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400d77ea",
  null
  
)

export default component.exports